module.exports = __webpack_public_path__ + "img/pgc-logo-faded.a2b345c0.png";